// import { useProduct, useProtectionPlan, useServiceAddOns } from '@thd-nucleus/data-sources';
// eslint-disable-next-line max-len
import { useProductDeprecated, useServiceAddOnsDeprecated, useProtectionPlanDeprecated } from '@thd-nucleus/data-sources/react/dataModel/migration';
import { hasPropertyEqualto } from '../utils/has-property-equal-to';

const CARPET_CLASS_NUM = 15;
const CARPET_SUBCLASS_NUM = 16;
const MAINTENANCE_SERVICE_TYPE = 'Maintenance';

const useProductAddOnsFlow = ({ itemId, storeId }) => {
  const domains = ['info', 'pricing', 'fulfillment', 'installServices', 'identifiers'];
  const { data: pData, error: pError, loading: pLoading } = useProductDeprecated({
    itemId, storeId, domains, ssr: false
  }, 'clientOnlyProduct');

  const {
    protectionPlanSku = false,
    hasServiceAddOns = false,
  } = pData?.product?.info || {};

  const inStoreAssemblyAvailable = pData?.product?.fulfillment?.inStoreAssemblyEligible;
  const { value } = pData?.product?.pricing || {};
  const { discontinued } = pData?.product?.availabilityType || {};

  const { data: ppData, error: ppError, loading: ppLoading } = useProtectionPlanDeprecated({
    protectionPlanParentId: protectionPlanSku,
    storeId,
    price: value || 0.00,
    skip: !protectionPlanSku,
    ssr: false,
  });

  const { data: sData, error: sError, loading: sLoading } = useServiceAddOnsDeprecated({
    itemId,
    storeId,
    ssr: false,
    skip: !hasServiceAddOns
  });

  const hasProtectionPlanData = (data) => {
    return data?.protectionPlan?.itemId && data?.protectionPlan?.price && data?.protectionPlan?.termLength;
  };

  const hasInstallationData = (data) => {
    const { installSkus = [] } = data?.serviceAddOns?.attachLabor || {};
    const { serviceType = '', installRetailPrice = {} } = (installSkus?.length && installSkus?.[0]) || {};
    return serviceType && serviceType !== MAINTENANCE_SERVICE_TYPE && installRetailPrice?.price;
  };

  const isInstallationSku = !discontinued && !!hasInstallationData(sData);
  const isAssembly = !discontinued && !!sData?.serviceAddOns?.proReferrals?.[0]?.assemblyCategory;
  const isProReferral = !discontinued && !!sData?.serviceAddOns?.proReferrals?.[0]?.available && !isAssembly;
  const isDualPath = !discontinued && !!sData?.serviceAddOns?.sellFurnishInstall?.dualPathSku;
  const isProtectionPlan = !discontinued && !!protectionPlanSku && hasProtectionPlanData(ppData);
  const isSAMDualPath = !discontinued && hasPropertyEqualto(
    {
      product: pData?.product,
      productDepartment: 23,
      classNumber: [1, 4, CARPET_CLASS_NUM],
      subClassNumber: [23, 22, 21, 17, 11, 20, 66, CARPET_SUBCLASS_NUM]
    }
  );

  const error = pError || ppError || sError;
  const loading = pLoading || ppLoading || sLoading;
  const data = {
    ...pData,
    ...ppData,
    ...sData
  };

  return {
    error,
    loading,
    data,
    isProtectionPlan,
    isProReferral,
    isAssembly,
    isDualPath,
    isInstallationSku,
    inStoreAssemblyAvailable,
    isSAMDualPath,
  };
};

export { useProductAddOnsFlow };
